<template>
  <div>
    <QHforget ref="QHforget" @hello="hello" @success="success"></QHforget>
    <QHlogin ref="QHlogin" @hello="hello" @success="success"></QHlogin>
    <QHzhuce ref="QHzhuce" @hello="hello" @success="success"></QHzhuce>
  </div>
</template>

<script>
import Vue from "vue";
import data from "./data.js";
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      loading: false,
      show: false,
      timer: "",
      count: 0,
      form: { ...data.data },
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | @Des:hello
    // +----------------------------------------------------------------------
    hello(show) {
      this.show = show;
      if (show == "QHforget") {
        this.$refs.QHlogin.show = false;
        this.$refs.QHforget.show = true;
        this.$refs.QHzhuce.show = false;
        return;
      }
      if (show == "QHlogin") {
        this.$refs.QHlogin.show = true;
        this.$refs.QHforget.show = false;
        this.$refs.QHzhuce.show = false;
        return;
      }
      if (show == "QHzhuce") {
        this.$refs.QHlogin.show = false;
        this.$refs.QHforget.show = false;
        this.$refs.QHzhuce.show = true;
        return;
      }
      this.$refs.QHlogin.show = false;
      this.$refs.QHforget.show = false;
      this.$refs.QHzhuce.show = false;
    },
    // +----------------------------------------------------------------------
    // | @Des:success
    // +----------------------------------------------------------------------
    success(res) {
      // 在这里处理 success 事件
      this.QHaccountEenter(res);
      this.$emit("success", res);
    },

    // +----------------------------------------------------------------------
    // | @Des:操作回调
    // +----------------------------------------------------------------------
    QHaccountEenter(res) {
      var that = this;
      //登录账号成功
      if (res.toolType == "QHlogin") {
        //清理缓存
        this.$clearStorage();

        //数据写入缓存
        const { token, ...nowUserGobal } = res.data;
        that.$setLocalStorage("nowUserGobal", nowUserGobal);
        that.$setLocalStorage("nowUserGobalTime", that.$getNowUnix());

        //全局存放用户信息
        Vue.prototype.$U = res.data;
        Vue.prototype.$A = res.data.auth;

        //七天内免登录
        if (this.form.isAgree) {
          localStorage.setItem("token", res.data.token);
          sessionStorage.setItem("token", null);
        }

        //关闭浏览器后就失效
        if (!this.form.isAgree) {
          sessionStorage.setItem("token", res.data.token);
          localStorage.setItem("token", null);
        }
        this.$msg("登录成功", "success");
        this.$getNowUserGobal();
        this.$getMYguanzhuzhuanli();
      }

      //注册账号成功
      if (res.toolType == "QHzhuce") {
        this.$msg("注册成功，请立即登录", "success");
        this.hello("QHlogin");
        this.$getNowUserGobal();
        this.$getMYguanzhuzhuanli();
      }

      //重置密码成功
      if (res.toolType == "QHforget") {
        this.$msg("重置密码成功，请立即登录", "success");
        this.hello("QHlogin");
        this.$getNowUserGobal();
        this.$getMYguanzhuzhuanli();
      }
    },
  },
};
</script>
